import styled from 'styled-components';
import { BlockedLinkWrapper } from '@cko/dashboard-shared';

export const StyledBlockedLinkWrapper = styled(BlockedLinkWrapper)`
    width: 100%;
`;